module.exports = __webpack_public_path__ + "media/stylesheets/opensans600-573e9313e05d89f4acb5d005476c61bb.woff";